/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { cached } from '@glimmer/tracking';
import {
  DISPUTE_EVIDENCE_FILE_FIELDS,
  DISPUTE_EVIDENCE_TEXT_FIELDS,
  type DisputeEvidenceFileField,
  type IDisputeEvidence,
} from 'uplisting-frontend/models/dispute';

const INLINE_VALUE_LENGTH = 44;

interface IArgs {
  evidence?: IDisputeEvidence;
  downloadingField?: DisputeEvidenceFileField;

  onDownload?(key: DisputeEvidenceFileField): void;
}

interface UiProtectionDisputePanelEvidenceSignature {
  Element: HTMLElement;

  Args: IArgs;
}

export interface IEvidenceField {
  key: string;
  value: string;
  isLong: boolean;
}

export default class UiProtectionDisputePanelEvidenceComponent extends Component<UiProtectionDisputePanelEvidenceSignature> {
  @cached
  get submitted(): boolean {
    return !!this.args.evidence?.submitted;
  }

  @cached
  get pastDue(): boolean {
    return !!this.args.evidence?.past_due;
  }

  @cached
  get submissionCount(): number {
    return this.args.evidence?.submission_count ?? 0;
  }

  @cached
  get wasResubmitted(): boolean {
    return this.submissionCount > 1;
  }

  @cached
  get fields(): IEvidenceField[] {
    const fields = this.args.evidence?.fields ?? {};

    return DISPUTE_EVIDENCE_TEXT_FIELDS.filter((key) => !!fields[key]).map(
      (key) => {
        const value = fields[key] as string;

        return { key, value, isLong: value.length > INLINE_VALUE_LENGTH };
      },
    );
  }

  @cached
  get documents(): DisputeEvidenceFileField[] {
    const files = this.args.evidence?.files ?? {};

    return DISPUTE_EVIDENCE_FILE_FIELDS.filter((key) => !!files[key]);
  }

  @cached
  get hasAnything(): boolean {
    return this.fields.length !== 0 || this.documents.length !== 0;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Ui::Protection::DisputePanel::Evidence': typeof UiProtectionDisputePanelEvidenceComponent;
    'ui/protection/dispute-panel/evidence': typeof UiProtectionDisputePanelEvidenceComponent;
  }
}
